module.exports = __webpack_public_path__ + "img/icone-ordem-valor-menor.b6d02e7c.svg";